export class Map {
    init()
    {
        $(document).ready(function(){
            // $( ".company-box__item" ).hide();
            // $('path').mouseover(function() {
            //     var id = $(this).attr("id");
            //     $("#"+id).css({ fill: "#555555" });
            //     $("#"+id+"_label").css({ fill: "#fff" });
            //
            //
            // });
            // $('path').mouseleave(function() {
            //     var id = $(this).attr("id");
            //     $("#"+id).css({ fill: "#d2dced" });
            //     $("#"+id+"_label").css({ fill: "#555" });
            //
            // });
                $("path.province").click(function(evt){
                    if(document.querySelector('.show-region')){
                        document.querySelector('.show-region').style.display = 'none';
                    }
                    var id = $(this).attr("id");
                    $( ".company-box__item" ).hide();
                    $( ".tip" ).hide();
                    $(".province").css({ fill: "#d2dced" });
                    $(".label").css({ fill: "#555" });

                    $( ".company-box__item."+id ).fadeIn(500);
                    $("#"+id).css({ fill: "#555555" });
                    $("#"+id+"_label").css({ fill: "#fff" });

                    let area ='';
                    switch (id) {
                        case 'area1':
                            area = "Szczecin";
                            break;
                        case 'area2':
                            area = "Gdańsk";
                            break;
                        case 'area3':
                            area = "Olsztyn";
                            break;
                        case 'area4':
                            area = "Toruń";
                            break;
                        case 'area5':
                            area = "Poznań";
                            break;
                        case 'area6':
                            area = "Warszawa";
                            break;
                        case 'area7':
                            area = "Białystok";
                            break;
                        case 'area8':
                            area = "Wrocław";
                            break;
                        case 'area9':
                            area = "Łódź";
                            break;
                        case 'area10':
                            area = "Katowice";
                            break;
                        case 'area11':
                            area = "Kraków";
                            break;
                        case 'area12':
                            area = "Lublin / Rzeszów";
                            break;
                    }
                    try {
                        if(area != ''){
                            // gtag('event', 'click', {'event_category': 'Gdzie kupić', 'event_label' : area});
                        }
                    } catch (error) {
                        console.error(error)
                    }
                });
                });
    }
}
